import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import QRCode from 'react-qr-code';
import { QrCodeWrapper, QrContainer, QrModalContainer, QrWrapper, ScanCodeText, } from './styles';
const QrModal = ({ scanQrCodeTitle, dashboardUrl }) => {
    const navigatorLink = dashboardUrl + '/app-links';
    return (_jsxs(QrModalContainer, { children: [_jsx(QrContainer, { children: _jsx(QrCodeWrapper, { children: _jsx(QrWrapper, { children: _jsx(QRCode, { value: navigatorLink, size: 160 }) }) }) }), _jsx(ScanCodeText, { type: "bodyButton", fontFamily: "primaryRegular", children: scanQrCodeTitle })] }));
};
export default QrModal;
//# sourceMappingURL=QrModal.js.map